import { Link, useNavigate } from 'react-router-dom';
import AdListImage from './AdListImage';
import Button from 'components/Button';
import TestEdildiBadge from 'components/TestEdildiBadge';
import { AdListing } from 'types/adListing';
import { listingService } from 'api';
import toast from 'bootstrap/js/dist/toast';
import { useState } from 'react';
import { useListingContext } from 'contexts/ListingContext';

interface AdListGridItemProps {
  ilan: AdListing;
  detailLinkBase?: string;
  onToggleFavorite?: (id: string | number, e: React.MouseEvent) => void;
  displayFavorites?: boolean;
  displayEdit?: boolean;
  displayDelete?: boolean;
}

export default function AdListGridItem({ 
  ilan, 
  detailLinkBase = '/ilan-detay', 
  onToggleFavorite, 
  displayFavorites = true,
  displayEdit = false,
  displayDelete = false,
}: AdListGridItemProps) {
  const isFavorite = ilan.isUserFavorite === true;
  const navigate = useNavigate();
  const { setDeletingListingId, setShowDeleteModal } = useListingContext();

  const handleEdit = () => {
    navigate(`/ilan-duzenle/${ilan.id}`);
  }

  const handleDelete = async (ilanId: string | number) => {
    setShowDeleteModal(true);
    setDeletingListingId(ilanId);
  }

  return (
    <div key={ilan.id} className="col">
      <div className="card h-100 product-card position-relative">
        {displayFavorites && <Button
          type="button"
          className={`btn position-absolute end-0 top-0 m-2 p-1 rounded-circle shadow-sm favorite-btn ${isFavorite ? 'active' : ''}`}
          style={{ backgroundColor: 'var(--sb-bg)' }}
          onClick={onToggleFavorite ? (e) => onToggleFavorite(ilan.id, e) : undefined}
        >
          <i className={`${isFavorite ? 'fas' : 'far'} fa-heart text-${isFavorite ? 'danger' : 'primary'}`} style={{ fontSize: '16px' }} />
        </Button>}

        <div
          className="position-absolute end-0 top-0 m-2 d-flex flex-column align-items-end"
          style={{ zIndex: 2, gap: '0.5rem' }}
        >
          {displayEdit && (
            <Button
              type="button"
              className="btn p-1 rounded-circle shadow-sm favorite-btn mb-1"
              style={{ backgroundColor: 'var(--sb-bg)' }}
              onClick={handleEdit}
            >
              <i className="fas fa-pencil text-primary" style={{ fontSize: '16px' }} />
            </Button>
          )}
          {displayDelete && (
            <Button
              type="button"
              className="btn p-1 rounded-circle shadow-sm favorite-btn"
              style={{ backgroundColor: 'var(--sb-bg)' }}
              onClick={() => handleDelete(ilan.id)}
            >
              <i className="fas fa-trash text-danger" style={{ fontSize: '16px' }} />
            </Button>
          )}
        </div>

        <AdListImage ilan={ilan} style={{ height: '200px', objectFit: 'cover' }} detailLink={detailLinkBase ? `${detailLinkBase}/${ilan.id}` : undefined} />

        {ilan.isTested && (
          <span className="position-absolute start-0 top-0 m-2" style={{ zIndex: 2 }}>
            <TestEdildiBadge compact />
          </span>
        )}

        <div className="card-body">
          <Link to={detailLinkBase ? `${detailLinkBase}/${ilan.id}` : `/ilan-detay/${ilan.id}`} className="text-decoration-none">
                        <h5 className="card-title">{ilan.baslik}</h5>
                    </Link>

          {ilan.rejectionReason ? (
            <div className="alert alert-danger py-2 px-2 small mb-2" role="status">
              <i className="fas fa-times-circle me-1" aria-hidden />
              <strong>Red gerekçesi:</strong> {ilan.rejectionReason}
            </div>
          ) : null}

          <p className="card-text text-muted small mb-3" style={{ height: '40px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {ilan.aciklama.length > 80 ? `${ilan.aciklama.substring(0, 80)}...` : ilan.aciklama}
                    </p>

          {/* Bilgisayar Özellikleri */}
                    {ilan.kategori === "Bilgisayar" && (
                        <div className="specs-container mb-3">
                            {ilan.islemci && (
                                <div className="spec-item">
                                    <div className="spec-icon me-2">
                                        <i className="fas fa-microchip text-primary"></i>
                                    </div>
                                    <small>{ilan.islemci}</small>
                                </div>
                            )}
                            {ilan.ekranKarti && (
                                <div className="spec-item">
                                    <div className="spec-icon me-2">
                                        <i className="fas fa-tv text-primary"></i>
                                    </div>
                                    <small>{ilan.ekranKarti}</small>
                                </div>
                            )}
                            {ilan.ram && (
                                <div className="spec-item">
                                    <div className="spec-icon me-2">
                                        <i className="fas fa-memory text-primary"></i>
                                    </div>
                                    <small>{ilan.ram}</small>
                                </div>
                            )}
                            {ilan.ssd && (
                                <div className="spec-item">
                                    <div className="spec-icon me-2">
                                        <i className="fas fa-solid fa-hdd text-primary"></i>
                                    </div>
                                    <small>SSD: {ilan.ssd}</small>
                                </div>
                            )}
                            {ilan.hdd && (
                                <div className="spec-item">
                                    <div className="spec-icon me-2">
                                        <i className="fas fa-hdd text-primary"></i>
                                    </div>
                                    <small>HDD: {ilan.hdd}</small>
                                </div>
                            )}
                        </div>
                    )}

          <div className="d-flex justify-content-between mt-auto">
            <small className="text-muted">
              <i className="fas fa-map-marker-alt me-1" />
              {ilan.konum}
            </small>
            <span className="h5 mb-0 text-primary fw-bold">{ilan.fiyat.toLocaleString('tr-TR')} ₺</span>
          </div>
        </div>
      </div>
    </div>
  );
}